import React, { useEffect, useState } from "react";
import { ButtonSpan } from "../../Components/Button";
import { connect, useSelector } from "react-redux";
import classnames from "classnames";
import { getFormValues } from "redux-form";
import { isSuperAgent } from "../../modules/auth";

const EnquiryTypeToggle = ({
  form,
  isSuperAgent,
  selectedAgencies,
  setEnquiryType,
  agencyFromTemplate,
}) => {
  const [enquiryTypes, setEnquiryTypes] = useState([]);
  const values = useSelector(getFormValues(form));

  useEffect(() => {
    if (isSuperAgent) {
      let enquiryTypesArray = [];
      selectedAgencies.length > 0 &&
        selectedAgencies.map(superAgency => {
          enquiryTypesArray.push({
            name: superAgency.name,
            code: superAgency.id,
            type: "is_" + superAgency.id + "_enquiry",
          });
        });
      setEnquiryTypes(enquiryTypesArray);
      if (agencyFromTemplate) {
        setEnquiryType(
          enquiryTypesArray.find(type => type.code === agencyFromTemplate)
        );
      }
    }
  }, [selectedAgencies]);

  if (enquiryTypes.length === 0) return null;

  return (
    <div className="row">
      <div className="col col-w-full mb-4">
        <div className="flex flex-wrap gap-2">
          {enquiryTypes?.map((enquiryType, key) => (
            <ButtonSpan
              key={key}
              className={classnames(
                "mt-2 md:w-1/5 w-auto text-center inline-block flex items-center px-4 py-2 border rounded-sm text-sm transition-all duration-300",
                {
                  "bg-white opacity-50":
                    values?.super_agency_code !== enquiryType.code,
                  "bg-brand text-white border-brand":
                    values?.super_agency_code === enquiryType.code,
                }
              )}
              onClick={() => setEnquiryType(enquiryType)}
            >
              {enquiryType.name} Enquiry
            </ButtonSpan>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.selectedAgencies,
    isSuperAgent: isSuperAgent(state),
  };
};

export default connect(mapStateToProps, null)(EnquiryTypeToggle);
